"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _libphonenumberJs = require("libphonenumber-js");
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _Select = _interopRequireDefault(require("../../elements/select/Select"));
var _formatInternationalPhoneNumber = _interopRequireDefault(require("../../form/normalizers/formatInternationalPhoneNumber"));
var _phoneNumberInternational = require("../../form/validation/phoneNumberInternational");
var _internationalPhoneNumberInputModule = _interopRequireDefault(require("./international-phone-number-input.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InternationalPhoneNumberInput = /*#__PURE__*/function (_Component) {
  function InternationalPhoneNumberInput(props) {
    var _this;
    _classCallCheck(this, InternationalPhoneNumberInput);
    _this = _callSuper(this, InternationalPhoneNumberInput, [props]);
    _defineProperty(_this, "onCountryCodeSelectChange", function (event) {
      var setFieldValue = _this.props.setFieldValue;
      var number = _this.state.number;
      var countryCode = event.target.value;
      var _InternationalPhoneNu = InternationalPhoneNumberInput.parseInputPhoneNumber(number, countryCode),
        value = _InternationalPhoneNu.value,
        isValid = _InternationalPhoneNu.isValid;
      _this.setState({
        countryCode: countryCode,
        value: value,
        isValid: isValid,
        imagePath: _this.getImagePath(countryCode),
        selectedLabel: _this.getSelectLabel(countryCode)
      }, function () {
        setFieldValue('phoneNumberCountryCode', countryCode);
        _this.onChange();
      });
    });
    _defineProperty(_this, "onNumberInputChange", function (event) {
      var setFieldValue = _this.props.setFieldValue;
      var inputValue = (0, _get["default"])(event, 'target.value', '');
      var number = (0, _formatInternationalPhoneNumber["default"])(inputValue);
      var countryCode = _this.state.countryCode;
      var _InternationalPhoneNu2 = InternationalPhoneNumberInput.parseInputPhoneNumber(number, countryCode),
        value = _InternationalPhoneNu2.value,
        isValid = _InternationalPhoneNu2.isValid;
      _this.setState({
        number: number,
        value: value,
        isValid: isValid
      }, function () {
        // TODO it doesn't make sense to do setFieldValue here but without it the min/max length
        // validation was ignored in favour of the regex validation, which means helpful error
        // messages are lost. Needs further investigation for a long-term solution
        if (isValid) {
          setFieldValue('phoneNumberCountryCode', countryCode);
        }
        _this.onChange();
      });
    });
    _defineProperty(_this, "onBlur", function () {
      var onBlur = _this.props.onBlur;
      var _this$state = _this.state,
        value = _this$state.value,
        number = _this$state.number;
      var valueToBlur = value || number;

      // ensure we only blur when we focus outside of this component
      setTimeout(function () {
        var el = document.activeElement;
        var isFocussed = el.id.indexOf('phoneNumber-') === 0;
        if (!isFocussed) {
          onBlur(valueToBlur);
        }
      }, 0);
    });
    _defineProperty(_this, "onChange", function () {
      var onChange = _this.props.onChange;
      var value = _this.state.value;
      onChange(value);
    });
    _defineProperty(_this, "onFocus", function () {
      var onFocus = _this.props.onFocus;
      var value = _this.state.value;
      onFocus(value);
    });
    _defineProperty(_this, "getCountry", function (countryCode) {
      var options = _this.props.options;
      return (0, _find["default"])(options, {
        value: countryCode
      }) || {};
    });
    _defineProperty(_this, "getSelectLabel", function (countryCode) {
      if (countryCode) {
        if (countryCode === 'other') {
          return 'Other';
        }
        var code = InternationalPhoneNumberInput.getCallingCode(countryCode);
        return "(+".concat(code, ")");
      }
      // TODO state.selectLabel doesn't exist, so this has always been resolving to ''
      // Either remove, or see if it's meant to be state.selectedLabel
      return (0, _get["default"])(_this.state, 'selectLabel', '');
    });
    _defineProperty(_this, "getImagePath", function (countryCode) {
      if (countryCode) {
        if (countryCode === 'other') {
          return '';
        }
        try {
          return require("../../assets/images/flags/".concat(countryCode.toLowerCase(), ".svg")); // eslint-disable-line
        } catch (_unused) {
          return '';
        }
      }
      return (0, _get["default"])(_this.state, 'imagePath', '');
    });
    var _this$props = _this.props,
      regionCode = _this$props.regionCode,
      _value = _this$props.value;
    var _InternationalPhoneNu3 = InternationalPhoneNumberInput.parseInitialPhoneNumber(_value, regionCode),
      _countryCode = _InternationalPhoneNu3.countryCode,
      _number = _InternationalPhoneNu3.number,
      _isValid = _InternationalPhoneNu3.isValid;
    _this.state = {
      countryCode: _countryCode,
      number: _number,
      isValid: _isValid,
      imagePath: _this.getImagePath(_countryCode),
      selectedLabel: _this.getSelectLabel(_countryCode)
    };
    return _this;
  }
  _inherits(InternationalPhoneNumberInput, _Component);
  return _createClass(InternationalPhoneNumberInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var setFieldValue = this.props.setFieldValue;
      var countryCode = this.state.countryCode;
      setFieldValue('phoneNumberCountryCode', countryCode);
    }

    // TODO either refactor to a non-deprecated method or refactor component to be stateless
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = this.state.value;
      if (value !== nextProps.value) {
        var regionCode = nextProps.regionCode;
        var _InternationalPhoneNu4 = InternationalPhoneNumberInput.parseInitialPhoneNumber(nextProps.value, regionCode),
          countryCode = _InternationalPhoneNu4.countryCode,
          number = _InternationalPhoneNu4.number,
          isValid = _InternationalPhoneNu4.isValid,
          newValue = _InternationalPhoneNu4.value;
        this.setState({
          countryCode: countryCode,
          number: number,
          isValid: isValid,
          value: newValue,
          imagePath: this.getImagePath(countryCode),
          selectedLabel: this.getSelectLabel(countryCode)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        id = _this$props2.id,
        options = _this$props2.options,
        inputClassName = _this$props2.inputClassName,
        disabled = _this$props2.disabled,
        maxLength = _this$props2.maxLength;
      var _this$state2 = this.state,
        countryCode = _this$state2.countryCode,
        number = _this$state2.number,
        imagePath = _this$state2.imagePath,
        selectedLabel = _this$state2.selectedLabel;
      var customSelectStyleModifier = !imagePath ? _internationalPhoneNumberInputModule["default"].noFlag : '';
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _internationalPhoneNumberInputModule["default"].container,
        "data-jlds": true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames["default"])(_internationalPhoneNumberInputModule["default"].customSelectOption, customSelectStyleModifier),
          "data-testid": "international-phone-number-custom-label",
          id: "countryName",
          "aria-hidden": "true",
          children: selectedLabel
        }), imagePath && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          alt: countryCode,
          className: _internationalPhoneNumberInputModule["default"].flag,
          src: imagePath,
          "aria-hidden": "true"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select["default"], {
          className: (0, _classnames["default"])(_internationalPhoneNumberInputModule["default"].countryCode, inputClassName),
          id: "".concat(id, "-countryCode"),
          name: "".concat(id, "-countryCode"),
          onChange: this.onCountryCodeSelectChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          options: options,
          value: countryCode,
          disabled: disabled,
          ariaDescribedBy: "countryName",
          ariaLabel: "Phone number country code"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], {
          type: "tel",
          className: (0, _classnames["default"])(_internationalPhoneNumberInputModule["default"].number, inputClassName),
          id: id,
          name: id,
          onChange: this.onNumberInputChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          value: number,
          disabled: disabled,
          maxLength: maxLength,
          ariaLabel: "Phone number"
        })]
      });
    }
  }], [{
    key: "parseInitialPhoneNumber",
    value: function parseInitialPhoneNumber(value, defaultCountryCode) {
      var countryCode = (0, _phoneNumberInternational.getCountryCode)(value, defaultCountryCode);
      try {
        var phoneNumber = (0, _libphonenumberJs.parsePhoneNumber)(value, countryCode);
        return {
          countryCode: phoneNumber.country || countryCode,
          number: phoneNumber.nationalNumber,
          value: phoneNumber.number,
          isValid: phoneNumber.isValid()
        };
      } catch (error) {
        var code = InternationalPhoneNumberInput.getCallingCode(countryCode);
        var regex = new RegExp("^((\\+(".concat(code, ")?)|(00(").concat(code, ")?))"));
        var number = value.replace(regex, '');
        return {
          countryCode: countryCode,
          number: number,
          value: value,
          isValid: false,
          error: true
        };
      }
    }
  }, {
    key: "parseInputPhoneNumber",
    value: function parseInputPhoneNumber(number, countryCode) {
      if (countryCode === 'other') {
        return {
          value: number,
          isValid: true
        };
      }
      try {
        var phoneNumber = (0, _libphonenumberJs.parsePhoneNumber)(number, countryCode);
        return {
          value: phoneNumber.number,
          isValid: phoneNumber.isValid()
        };
      } catch (error) {
        var code = InternationalPhoneNumberInput.getCallingCode(countryCode);
        var value = number ? "+".concat(code).concat(number) : '';
        return {
          value: value,
          isValid: false
        };
      }
    }
  }, {
    key: "getCallingCode",
    value: function getCallingCode(countryCode) {
      try {
        return (0, _libphonenumberJs.getCountryCallingCode)(countryCode);
      } catch (error) {
        return '';
      }
    }
  }]);
}(_react.Component);
_defineProperty(InternationalPhoneNumberInput, "propTypes", {
  /** Id of the field (will be value key in redux-form state object) */
  id: _propTypes["default"].string,
  /** Value of the field (eg: +447873336666, this is parsed into country code and number) */
  value: _propTypes["default"].string,
  /** Options array for the country selector */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  /** Optional classname to apply to each of the inputs */
  inputClassName: _propTypes["default"].string,
  /** Add disabled attribute to each of the inputs */
  disabled: _propTypes["default"].bool,
  /** Max length chars allowed in number input */
  maxLength: _propTypes["default"].number,
  /** Code that can be used to setup default state if countryCode cannot be parsed from value */
  regionCode: _propTypes["default"].string,
  /** Callback when we want to trigger a change for this field (provided by redux-form/Field component) */
  onChange: _propTypes["default"].func,
  /** Callback when we want to trigger a blur for this field (provided by redux-form/Field component) */
  onBlur: _propTypes["default"].func,
  /** Callback when we want to trigger a focus for this field (provided by redux-form/Field component) */
  onFocus: _propTypes["default"].func,
  /** Function to allow this field to set the value of another field in containing form (provided by jl-ui-kit/Form component) */
  setFieldValue: _propTypes["default"].func
});
_defineProperty(InternationalPhoneNumberInput, "defaultProps", {
  id: '',
  value: '',
  options: undefined,
  inputClassName: '',
  disabled: false,
  maxLength: 20,
  regionCode: 'GB',
  //
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  setFieldValue: function setFieldValue() {}
});
var _default = exports["default"] = InternationalPhoneNumberInput;